// extracted by mini-css-extract-plugin
module.exports = {"deviceGroupsLayout":"DeviceGroupLayout_deviceGroupsLayout__B1uIw","deviceGroupsTable":"DeviceGroupLayout_deviceGroupsTable__278ez"};